exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-details-container[data-v-5b600748]{height:70vh;overflow-y:auto}.modal-header[data-v-5b600748]{height:100%}.preview-question[data-v-5b600748]{font-family:artifaktElementBold}", ""]);

// exports
